const API_MEDIA_BASE =
  (process.env.REACT_APP_API_URL || 'https://dentoxcellence-backend.dentoxcellence.workers.dev/api').replace(
    /\/api\/?$/,
    ''
  );

const LEGACY_BACKEND_HOST = 'dentoxcellence-backend.boufaamoundir.workers.dev';
const CURRENT_BACKEND_HOST = 'dentoxcellence-backend.dentoxcellence.workers.dev';

function normalizeBackendMediaUrl(url) {
  if (!url || typeof url !== 'string') return '';
  let normalized = url.trim();
  if (!normalized) return '';

  normalized = normalized.replace(LEGACY_BACKEND_HOST, CURRENT_BACKEND_HOST);
  normalized = normalized.replace('/api/media/', '/media/');

  if (normalized.startsWith('http')) return normalized;
  if (normalized.startsWith('/media/')) return `${API_MEDIA_BASE}${normalized}`;
  if (normalized.startsWith('/api/media/')) {
    return `${API_MEDIA_BASE}${normalized.replace(/^\/api/, '')}`;
  }
  if (normalized.startsWith('data:') || normalized.startsWith('blob:')) return normalized;
  if (normalized.startsWith('/')) return normalized;
  if (/^[0-9a-f-]{36}$/i.test(normalized)) return `${API_MEDIA_BASE}/media/image/${normalized}.png`;

  return normalized;
}

/**
 * Resolve a display URL from CMS media objects or plain URL strings.
 */
export function getMediaUrl(item) {
  if (!item) return '';

  if (typeof item === 'string') {
    return normalizeBackendMediaUrl(item);
  }

  if (typeof item !== 'object') return '';

  if (item.data && typeof item.data === 'string') {
    return normalizeBackendMediaUrl(item.data);
  }

  if (item.image && typeof item.image === 'string') {
    return normalizeBackendMediaUrl(item.image);
  }

  if (item.public_url && typeof item.public_url === 'string') {
    return normalizeBackendMediaUrl(item.public_url);
  }

  if (item.file_url && typeof item.file_url === 'string') {
    return normalizeBackendMediaUrl(item.file_url);
  }

  const uuid = item.uuid || item.id;
  if (uuid && typeof uuid === 'string' && /^[0-9a-f-]{36}$/i.test(uuid)) {
    const ext = (item.extension || 'png').toLowerCase();
    return `${API_MEDIA_BASE}/media/image/${uuid}.${ext}`;
  }

  return '';
}

export function normalizeGalleryItem(item) {
  if (!item || typeof item !== 'object') return item;

  const url = getMediaUrl(item);
  if (!url) return item;

  return {
    ...item,
    data: url,
    type: item.type || 'image',
    public_url: item.public_url || (url.startsWith('http') ? url : undefined),
  };
}

export { API_MEDIA_BASE };
